<template>
<div>
  <v-dialog
      v-model="PLANNER_LOADING"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        dark
      >
        <v-card-text>
          Daten werden geladen..
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  <div class="table-outer-wrap" v-if="!PLANNER_LOADING">
    <div class="table-wrap">
      <div class="divTable">
        <div class="divTableBody">
          <div class="divTableRow">
            <div class="divTableCell"><h4>Mitarbeiter</h4></div>
            <div class="divTableCell" v-bind:class="isToday(day)" v-for="day in days" v-bind:key="(day.year() * 100000) + day.dayOfYear()">{{ day | moment('DD/MM') }}</div>
          </div>
          <div class="divTableRow" v-for="user in PLANNER_INDEX" v-bind:key="user.id">
            <div class="divTableCell roominfo">
              <p>{{ user.name }}</p>
            </div>
            <div class="divTableCell" v-for="day in days" v-bind:key="(day.year() * 100000) + day.dayOfYear() + user.name">
              <p @click="selectSalesOrder(salesOrder)" class="salesorder" v-for="salesOrder in getSalesOrders(day, user)" v-bind:key="salesOrder.id">{{ salesOrder.name }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <v-dialog
    v-model="dialog"
    max-width="500px"
  >
    <v-card v-if="selected">
      <v-card-title>{{ selected.name }}</v-card-title>
      <v-card-text>
        <p>{{ selected.customer }}</p>
        <p v-if="selected.subname">{{ selected.subname }}</p>
        <p>{{ selected.address }}</p>
        <p v-if="selected.pivot">{{ selected.pivot.begin | moment('DD/MM') }} - {{ selected.pivot.end | moment('DD/MM') }}</p>
      </v-card-text>
    </v-card>
  </v-dialog>

</div>

</template>

<script>
import { mapGetters } from 'vuex'
import { PLANNER_INDEX, PLANNER_LOADING } from '../../store/actions/planner'
export default {
  data () {
    return {
      selected: null,
      dialog: false
    }
  },
  computed: {
    ...mapGetters([
      PLANNER_INDEX, PLANNER_LOADING
    ]),
    days () {
      let days = []
      for (let i = (this.$moment()); i < (this.$moment().add('days', 20)); i.add('days', 1)) {
        days = [...days, i.clone()]
      }
      return days
    }
  },
  mounted () {
    this.$store.dispatch(PLANNER_INDEX)
  },
  methods: {
    getSalesOrders (day, user) {
      return user.sales_orders.filter((saleOrder) => {
        return ((day.isSameOrAfter(saleOrder.pivot.begin, 'day')) && day.isSameOrBefore(saleOrder.pivot.end, 'day'))
      })
    },
    getBookedClas (year, day, bookings) {
      if (this.getBookings(day, bookings) === undefined) {
        return false
      } else {
        return 'booked'
      }
    },
    isToday (day) {
      return this.$moment().dayOfYear() === day ? 'today' : false
    },
    selectSalesOrder (salesOrder) {
      this.dialog = true
      this.selected = {...salesOrder}
    }
  }
}
</script>
<style scoped>
.divTable {
  display: table;
  width: 100%;
}
.divTableRow {
  display: table-row;
}
.divTableHeading {
  background-color: #eee;
  display: table-header-group;
}
.divTableCell,
.divTableHead {
  border-right: 1px solid rgba(0,0,0,.12);
  border-bottom: 1px solid rgba(0,0,0,.12);
  display: table-cell;
  padding: 3px 10px;
  width: 40px;
  height: 100px;
}
.divTableCell:first-child {
  background-color: #f2f1f0;
  position: absolute;
  min-width: 100px;
  left: 0;
}
.divTableHeading {
  background-color: #eee;
  display: table-header-group;
  font-weight: bold;
}
.divTableFoot {
  background-color: #eee;
  display: table-footer-group;
  font-weight: bold;
}
.divTableBody {
  display: table-row-group;
}
.table-outer-wrap {
  position: relative;
}
.table-wrap {
  overflow-x: scroll;
  padding-left: 100px;
  overflow-y: visible;
  padding-bottom: 1px;
}
.roomname {
  font-size: 16px;
  font-weight: bold;
}
.roominfo p {
  margin-bottom: 5px;
}
.booked {
  background: red;
}
.today {
  background: yellow;
}
.salesorder {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #1867c0;
  color: #fff;
  border: 1px solid #1867c0;
  width: 100%;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/Planner/Index.vue